import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

const CustomDateInput = forwardRef(
  (
    { value, onClick, isInvalid, isValid, formControlProps, errorMessage },
    ref
  ) => {
    return (
      <>
        <Form.Control
          ref={ref}
          isInvalid={isInvalid}
          isValid={isValid}
          value={value}
          onClick={onClick}
          {...formControlProps}
          autoComplete="off"
        />
        <Form.Control.Feedback type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </>
    );
  }
);

const WizardInput = ({
  label,
  name,
  errors,
  type = 'text',
  options = [],
  placeholder,
  formControlProps,
  formGroupProps,
  setValue,
  datepickerProps,
  handleOnChange,
  onBlur,
  onChange
}) => {
  const [date, setDate] = useState(null);

  if (type === 'date') {
    return (
      <Form.Group {...formGroupProps}>
        <Row>
          <Col xs={4} className="d-flex justify-content-end pt-1">
            {!!label && <Form.Label>{label}</Form.Label>}
          </Col>
          <Col xs={4}>
            <DatePicker
              selected={date}
              onChange={date => {
                setDate(date);
                setValue(name, date);
              }}
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={30}
              showMonthDropdown
              maxDate={new Date()}
              minDate={new Date(new Date().getFullYear() - 30, 0)}
              customInput={
                <CustomDateInput
                  formControlProps={formControlProps}
                  errorMessage={errors[name]?.message}
                  isInvalid={errors[name]}
                  isValid={Object.keys(errors).length > 0 && !errors[name]}
                />
              }
              {...datepickerProps}
            />
          </Col>
        </Row>
      </Form.Group>
    );
  }

  if (type === 'checkbox' || type === 'switch' || type === 'radio') {
    return (
      <Form.Check type={type} id={name + Math.floor(Math.random() * 100)}>
        <Form.Check.Input
          type={type}
          {...formControlProps}
          isInvalid={errors[name]}
          isValid={Object.keys(errors).length > 0 && !errors[name]}
        />
        <Form.Check.Label className="ms-2">{label}</Form.Check.Label>
        <Form.Control.Feedback type="invalid" className="mt-0">
          {errors[name]?.message}
        </Form.Control.Feedback>
      </Form.Check>
    );
  }
  if (type === 'select') {
    return (
      <Form.Group {...formGroupProps}>
        <Row>
          <Col xs={4} className="d-flex justify-content-end pt-1">
            <Form.Label>{label}</Form.Label>
          </Col>
          <Col xs={4}>
            <Form.Select
              type={type}
              {...formControlProps}
              isInvalid={errors[name]}
              isValid={Object.keys(errors).length > 0 && !errors[name]}
              onChange={handleOnChange}
            >
              <option value="">{placeholder}</option>
              {options.map(option => (
                <option value={option.id} key={option.id}>
                  {option.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors[name]?.message}
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Form.Group>
    );
  }
  if (type === 'textarea') {
    return (
      <Form.Group {...formGroupProps}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          as="textarea"
          placeholder={placeholder}
          {...formControlProps}
          isValid={Object.keys(errors).length > 0 && !errors[name]}
          isInvalid={errors[name]}
          rows={4}
        />
        <Form.Control.Feedback type="invalid">
          {errors[name]?.message}
        </Form.Control.Feedback>
      </Form.Group>
    );
  }
  if (type === 'file') {
    return (
      <Form.Group {...formGroupProps}>
        <Row>
          <Col xs={4} className="d-flex justify-content-end pt-1">
            <Form.Label>{label}</Form.Label>
          </Col>
          <Col xs={4}>
            <Form.Control
              type="file"
              {...formControlProps}
              isInvalid={errors[name]}
              isValid={Object.keys(errors).length > 0 && !errors[name]}
              onChange={onChange}
            />
            <Form.Control.Feedback type="invalid">
              {errors[name]?.message}
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Form.Group>
    );
  }
  return (
    <Form.Group {...formGroupProps}>
      <Row>
        <Col xs={4} className="d-flex justify-content-end pt-1">
          <Form.Label>{label}</Form.Label>
        </Col>
        <Col xs={4}>
          <Form.Control
            type={type}
            placeholder={placeholder}
            {...formControlProps}
            isInvalid={errors[name]}
            isValid={Object.keys(errors).length > 0 && !errors[name]}
            onBlur={onBlur}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors[name]?.message}
          </Form.Control.Feedback>
        </Col>
      </Row>
    </Form.Group>
  );
};

CustomDateInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  isInvalid: PropTypes.bool,
  isValid: PropTypes.bool,
  formControlProps: PropTypes.object,
  errorMessage: PropTypes.string
};

WizardInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  type: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  formControlProps: PropTypes.object,
  formGroupProps: PropTypes.object,
  setValue: PropTypes.func,
  datepickerProps: PropTypes.object,
  handleOnChange: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func
};

WizardInput.defaultProps = { required: false };

export default WizardInput;
